export const WEB_URL = 'https://www.salve.sk/';
export const TERMS_AND_CONDITIONS_URL = 'https://salve.sk/pravidla-a-podmienky-pouzivania';
export const DATA_PROTECTION_POLICY_URL = 'https://salve.sk/ochrana-osobnych-udajov';
export const LOGO_SIZE = 48;
export const PRODUCT_START_FLOW_ENABLED = false;
export const PROCESSES_ENABLED = false;
export const CALCULATORS_ENABLED = false;
